import React, { useState, useEffect } from 'react';

const DCFInput = ({ label, value, onChange, placeholder }) => (
    <label className="dcf-row">
        <span>{label}</span>
        <input
            type="number"
            value={value}
            onChange={onChange}
            placeholder={placeholder}
        />
    </label>
);

const DCF = (props) => {
    // Default state for all the fields
    const [timePeriod, setTimePeriod] = useState(10); // Default is 10 years
    const [discountRate, setDiscountRate] = useState(20); // Default is 20%
    const [safetyFactor, setSafetyFactor] = useState(25); // Default is 25%
    const [growth, setGrowth] = useState(15); // Default is 15%
    const [priceRatio, setPriceRatio] = useState(20); // Default is 20
    const [currentPrice, setCurrentPrice] = useState(100); // Default is $100 current price

    const [calculatedValue, setCalculatedValue] = useState(0); // State for calculated value

    // Calculate DCF value whenever inputs change
    useEffect(() => {
        if (discountRate > 0 && safetyFactor < 100) {
            // Calculate Future Price
            const futurePrice =
                currentPrice * Math.pow(1 + growth / 100, timePeriod);

            // Discount Future Price to Present Value
            const presentValue =
                futurePrice / Math.pow(1 + discountRate / 100, timePeriod);

            // Apply Safety Factor
            const value = presentValue * (1 - safetyFactor / 100);

            setCalculatedValue(value.toFixed(2)); // Set the value rounded to 2 decimal places
        } else {
            setCalculatedValue(0); // If inputs are invalid, set value to 0
        }
    }, [
        growth,
        priceRatio,
        discountRate,
        safetyFactor,
        timePeriod,
        currentPrice,
    ]);

    // Handlers for input changes
    const handleTimePeriodChange = (e) => {
        setTimePeriod(e.target.value);
    };

    const handleDiscountRateChange = (e) => {
        setDiscountRate(e.target.value);
    };

    const handleSafetyFactorChange = (e) => {
        setSafetyFactor(e.target.value);
    };

    const handleGrowthChange = (e) => {
        setGrowth(e.target.value);
    };

    const handlePriceRatioChange = (e) => {
        setPriceRatio(e.target.value);
    };

    const handleCurrentPriceChange = (e) => {
        setCurrentPrice(e.target.value);
    };

    return (
        <div className="widget dcf-widget">
            <h4 className="widget-header">DCF</h4>
            <DCFInput
                label="Current Price"
                value={currentPrice}
                onChange={handleCurrentPriceChange}
                placeholder="Current Price ($)"
            />
            <DCFInput
                label="Time Period"
                value={timePeriod}
                onChange={handleTimePeriodChange}
                placeholder="Time Period (years)"
            />
            <DCFInput
                label="Discount Rate"
                value={discountRate}
                onChange={handleDiscountRateChange}
                placeholder="Discount Rate (%)"
            />
            <DCFInput
                label="Safety Factor"
                value={safetyFactor}
                onChange={handleSafetyFactorChange}
                placeholder="Safety Factor (%)"
            />
            <DCFInput
                label="Growth"
                value={growth}
                onChange={handleGrowthChange}
                placeholder="Growth (%)"
            />
            <DCFInput
                label="Price Ratio"
                value={priceRatio}
                onChange={handlePriceRatioChange}
                placeholder="Price Ratio"
            />
            <div className="dcf-result">
                <span>Calculated DCF Value</span>
                <strong>${calculatedValue}</strong>
            </div>
        </div>
    );
};

export default DCF;
